///staffshift/list
export const STAFF_PLANNER_LIST_REQUEST = "STAFF_PLANNER_LIST_REQUEST";
export const STAFF_PLANNER_LIST_SUCCESS = "STAFF_PLANNER_LIST_SUCCESS";
export const STAFF_PLANNER_LIST_FAIL = "STAFF_PLANNER_LIST_FAIL";
///staffshift/data/
export const STAFF_PLANNER_DATA_REQUEST = "STAFF_PLANNER_DATA_REQUEST";
export const STAFF_PLANNER_DATA_SUCCESS = "STAFF_PLANNER_DATA_SUCCESS";
export const STAFF_PLANNER_DATA_FAIL = "STAFF_PLANNER_DATA_FAIL";
///staffshift/create
export const STAFF_PLANNER_CREATE_REQUEST = "STAFF_PLANNER_CREATE_REQUEST";
export const STAFF_PLANNER_CREATE_SUCCESS = "STAFF_PLANNER_CREATE_SUCCESS";
export const STAFF_PLANNER_CREATE_FAIL = "STAFF_PLANNER_CREATE_FAIL";
///staffshift/update
export const STAFF_PLANNER_UPDATE_REQUEST = "STAFF_PLANNER_UPDATE_REQUEST";
export const STAFF_PLANNER_UPDATE_SUCCESS = "STAFF_PLANNER_UPDATE_SUCCESS";
export const STAFF_PLANNER_UPDATE_FAIL = "STAFF_PLANNER_UPDATE_FAIL";
///staffshift/delete
export const STAFF_PLANNER_DELETE_REQUEST = "STAFF_PLANNER_DELETE_REQUEST";
export const STAFF_PLANNER_DELETE_SUCCESS = "STAFF_PLANNER_DELETE_SUCCESS";
export const STAFF_PLANNER_DELETE_FAIL = "STAFF_PLANNER_DELETE_FAIL";
///staffshift/search
export const STAFF_PLANNER_SEARCH_REQUEST = "STAFF_PLANNER_SEARCH_REQUEST";
export const STAFF_PLANNER_SEARCH_SUCCESS = "STAFF_PLANNER_SEARCH_SUCCESS";
export const STAFF_PLANNER_SEARCH_FAIL = "STAFF_PLANNER_SEARCH_FAIL";
///staffshift/complete
export const STAFF_PLANNER_COMPLETE_REQUEST = "STAFF_PLANNER_COMPLETE_REQUEST";
export const STAFF_PLANNER_COMPLETE_SUCCESS = "STAFF_PLANNER_COMPLETE_SUCCESS";
export const STAFF_PLANNER_COMPLETE_FAIL = "STAFF_PLANNER_COMPLETE_FAIL";
///staffshift/generaterecurrence
export const STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST =
  "STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST";
export const STAFF_PLANNER_GENERATE_RECURRENCE_SUCCESS =
  "STAFF_PLANNER_GENERATE_RECURRENCE_SUCCESS";
export const STAFF_PLANNER_GENERATE_RECURRENCE_FAIL =
  "STAFF_PLANNER_GENERATE_RECURRENCE_FAIL";
///staffshift/uninvoiced
export const STAFF_PLANNER_UNINVOICED_REQUEST =
  "STAFF_PLANNER_UNINVOICED_REQUEST";
export const STAFF_PLANNER_UNINVOICED_SUCCESS =
  "STAFF_PLANNER_UNINVOICED_SUCCESS";
export const STAFF_PLANNER_UNINVOICED_FAIL = "STAFF_PLANNER_UNINVOICED_FAIL";
///staffshift/converttoinvoice
export const STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST =
  "STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST";
export const STAFF_PLANNER_CONVERT_TO_INVOICE_SUCCESS =
  "STAFF_PLANNER_CONVERT_TO_INVOICE_SUCCESS";
export const STAFF_PLANNER_CONVERT_TO_INVOICE_FAIL =
  "STAFF_PLANNER_CONVERT_TO_INVOICE_FAIL";
///staffshiftstatus/list
export const STAFF_PLANNER_STATUS_LIST_REQUEST =
  "STAFF_PLANNER_STATUS_LIST_REQUEST";
export const STAFF_PLANNER_STATUS_LIST_SUCCESS =
  "STAFF_PLANNER_STATUS_LIST_SUCCESS";
export const STAFF_PLANNER_STATUS_LIST_FAIL = "STAFF_PLANNER_STATUS_LIST_FAIL";
///staffshiftrecentactivity/list
export const STAFF_PLANNER_RECENT_ACTIVITY_REQUEST =
  "STAFF_PLANNER_RECENT_ACTIVITY_REQUEST";
export const STAFF_PLANNER_RECENT_ACTIVITY_SUCCESS =
  "STAFF_PLANNER_RECENT_ACTIVITY_SUCCESS";
export const STAFF_PLANNER_RECENT_ACTIVITY_FAIL =
  "STAFF_PLANNER_RECENT_ACTIVITY_FAIL";
///staffshiftassignment/list
export const STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST =
  "STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST";
export const STAFF_PLANNER_ASSIGNMENT_LIST_SUCCESS =
  "STAFF_PLANNER_ASSIGNMENT_LIST_SUCCESS";
export const STAFF_PLANNER_ASSIGNMENT_LIST_FAIL =
  "STAFF_PLANNER_ASSIGNMENT_LIST_FAIL";
///staffshiftassignment/data
export const STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST =
  "STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST";
export const STAFF_PLANNER_ASSIGNMENT_DATA_SUCCESS =
  "STAFF_PLANNER_ASSIGNMENT_DATA_SUCCESS";
export const STAFF_PLANNER_ASSIGNMENT_DATA_FAIL =
  "STAFF_PLANNER_ASSIGNMENT_DATA_FAIL";
///staffshiftassignment/create
export const STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST =
  "STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST";
export const STAFF_PLANNER_ASSIGNMENT_CREATE_SUCCESS =
  "STAFF_PLANNER_ASSIGNMENT_CREATE_SUCCESS";
export const STAFF_PLANNER_ASSIGNMENT_CREATE_FAIL =
  "STAFF_PLANNER_ASSIGNMENT_CREATE_FAIL";
///staffshiftassignment/update
export const STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST =
  "STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST";
export const STAFF_PLANNER_ASSIGNMENT_UPDATE_SUCCESS =
  "STAFF_PLANNER_ASSIGNMENT_UPDATE_SUCCESS";
export const STAFF_PLANNER_ASSIGNMENT_UPDATE_FAIL =
  "STAFF_PLANNER_ASSIGNMENT_UPDATE_FAIL";
///staffshiftassignment/delete
export const STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST =
  "STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST";
export const STAFF_PLANNER_ASSIGNMENT_DELETE_SUCCESS =
  "STAFF_PLANNER_ASSIGNMENT_DELETE_SUCCESS";
export const STAFF_PLANNER_ASSIGNMENT_DELETE_FAIL =
  "STAFF_PLANNER_ASSIGNMENT_DELETE_FAIL";
///staffshiftassignment/assign
export const STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST =
  "STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST";
export const STAFF_PLANNER_ASSIGNMENT_ASSIGN_SUCCESS =
  "STAFF_PLANNER_ASSIGNMENT_ASSIGN_SUCCESS";
export const STAFF_PLANNER_ASSIGNMENT_ASSIGN_FAIL =
  "STAFF_PLANNER_ASSIGNMENT_ASSIGN_FAIL";
///staffshiftassignment/unassign
export const STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST =
  "STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST";
export const STAFF_PLANNER_ASSIGNMENT_UNASSIGN_SUCCESS =
  "STAFF_PLANNER_ASSIGNMENT_UNASSIGN_SUCCESS";
export const STAFF_PLANNER_ASSIGNMENT_UNASSIGN_FAIL =
  "STAFF_PLANNER_ASSIGNMENT_UNASSIGN_FAIL";
